import { useMemo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import { useInfiniteKitProducts } from '@Queries/Kit';
import { useDeps } from '@Contexts/DI';
import * as ModalWindows from '@Stores/ModalWindows';
import useMedias from '@Hooks/useMedias';
import Img from '@UI/Img';
import Button from './elems/Button';
import Product from './elems/Product';
import ImgSale from './image/Sale2.gif';
import styles from './Kits.module.css';

import type { FC, HTMLAttributes } from 'react';

interface KitsProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  text?: string;
  isUnavailable: boolean;
  mainProductId: number;
}

const Kits: FC<KitsProps> = (props) => {
  const { title, text, mainProductId, isUnavailable, className } = props;
  const { t } = useTranslation();
  const { data: infiniteData } = useInfiniteKitProducts(mainProductId);
  const { isMobile, isDesktopL } = useMedias();
  const { analytics } = useDeps();

  const selectedProduct = useMemo(() => {
    const products = infiniteData?.pages.flatMap((page) => page.changedProducts);
    const product = (products || []).find((item) => item.quantity === 1);

    return product;
  }, [infiniteData]);

  const btnName = selectedProduct ? 'change' : 'choose';

  const handleClick = () => {
    if (isUnavailable) return;
    ModalWindows.open('KitCheaper', { mainProductId: mainProductId });
    analytics.dispatchEvent('kits.openModal', { title: infiniteData?.pages[0]?.title });
  };

  return (
    <div className={cn(styles.main, className)} onClick={handleClick}>
      <div className={cn(styles.top, { [styles.transparent]: isUnavailable })}>
        <Img src={ImgSale} className={styles.img} />
        <div className={styles.topContent}>
          <div className={styles.textWrapper}>
            <h2 className={styles.title}>{title || t('kits.title')}</h2>
            {!selectedProduct && text && <RawHtml className={styles.offer} html={text} />}
          </div>
          {!isMobile && !isUnavailable && (
            <Button className={styles.btn} view={isDesktopL ? btnName : 'arrow'} />
          )}
        </div>
      </div>

      {selectedProduct && (
        <Product
          product={selectedProduct}
          isUnavailable={isUnavailable}
          mainProductId={mainProductId}
          className={styles.product}
        />
      )}
      {isMobile && !isUnavailable && <Button className={styles.btn} view={btnName} />}
      {isUnavailable && <p className={styles.note}>{t('kits.condition')}</p>}
    </div>
  );
};

export default Kits;
